import(/* webpackMode: "eager" */ "/personal-project/app/global-error.tsx")